export const getLink = (link: any) => {
  if (link.type === 'custom') {
    return link.url
  }

  if (link.type === 'reference') {
    if (!link.reference?.value?.slug) {
      return '/'
    }
    if (link.reference?.relationTo === 'pages') {
      return `/${link.reference?.value?.slug}`
    }
    return `/${link.reference?.relationTo}/${link.reference?.value?.slug}`
  }

  return '/'
}
